var React = require('react');

function BookmarkArticle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none"},[React.createElement("path",{"d":"M11.5 1.5h12v22h-23v-22h3","key":0}),React.createElement("path",{"d":"M11.5 13.5l-4-4-4 4v-13h8zM14.5 7.5h6M14.5 10.5h6M14.5 13.5h6M3.5 16.5h17M3.5 19.5h13","key":1})]));
}

BookmarkArticle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BookmarkArticle;

BookmarkArticle.default = BookmarkArticle;
